import { Component, Input, ElementRef } from '@angular/core';
import { encapsulation } from '../encapsulation';
import { UBXForm, UBXField, UBXFieldTypeEnum, UBXFieldErrorEnum } from '../../models';

@Component({
    selector: 'ubx-form',
    templateUrl: './form.component.html',
    host: { class: 'ubx-form d:b' },
    encapsulation
})
export class UBXFormComponent {
    @Input() accent = 'prm';
    @Input() columns = '6-6';
    @Input() gap: string;
    @Input() xGap: string;

    @Input() showRequiredFootnote = false;
    @Input() data: UBXForm<any>;

    showHide: boolean;

    FieldType = UBXFieldTypeEnum;

    constructor(
        public el: ElementRef,
    ) { }

    setGrid(value: string): string {
        return value && `${value} 1@m`;
    }
    setAlign(value: string): string {
        return value && value;
    }

    setInputbox(value: any, field: UBXField) {
        this.setValue(value, field);
    }
    setCheckbox(value: any, field: UBXField) {
        this.setValue(value, field);
        if (field.checkbox?.onClick) {
            field.checkbox?.onClick(value);
            field.checkbox.isChecked = value;
        }
    }
    setSelect(value: any, field: UBXField) {
        this.setValue(value, field);
        if (field.select?.onClick) {
            field.select?.onClick(value);
        }
    }
    setRadioButton(value: any, field: UBXField) {
        this.setValue(value, field);
        if (field.radio?.onClick) {
            field.radio?.onClick(value);
        }
    }
    setUpload(value: any, field: UBXField) {
        this.setValue(value, field);
    }
    showHidePassword(showHide: boolean) {
        this.showHide = showHide ? false : true;
    }

    getValue(field: UBXField): any {
        return field.name.split('.').reduce((pre, cur) => pre[cur], this.data.model);
    }

    private setValue(value: any, field: UBXField) {
        let model = this.data.model;
        field.name.split('.').forEach((key, index, arr) => {
            model = model[key] = index === arr.length - 1 ? value : model[key];
        });
        this.resetValidation(field);
    }

    requiredFootnote(data: UBXForm<any>): boolean {
        const requiredCheck = [];
        data.fields.forEach((field) => {
            requiredCheck.push(field.validation?.required);
        });
        return requiredCheck.indexOf(true) !== -1 ? true : false;
    }

    isFormValid(): boolean {
        this.data.fields.forEach((field: UBXField) => {
            this.checkValidation(field);
        });
        const isValid = this.data.fields.filter((field: UBXField) => !field.isValid).length;
        return isValid === 0;
    }

    private checkValidation(field: UBXField) {
        if (!field.validation) {
            return;
        }
        this.resetHidden(field);
        if (field.validation.required) {
            field.isValid = this.checkRequired(field);
            this.showError(field, UBXFieldErrorEnum.Required);
        }
    }

    private resetValidation(field: UBXField) {
        field.isValid = true;
        if (field.message && field.error) {
            field.message.show = true;
            field.error.show = false;
        }
    }

    private showError(field: UBXField, error: UBXFieldErrorEnum) {
        if (!field.isValid) {
            field.message = {
                type: field.message?.type,
                show: false,
                content: field.message?.content,
                accent: field.message?.accent,
                align: field.message?.align
            };
            field.error = {
                type: error,
                show: true,
            };
        }
    }

    private resetHidden(field: UBXField) {
        if (field.isHidden) {
            this.setValue(undefined, field);
            field.isValid = true;
        }
    }

    private checkRequired(field: UBXField): boolean {
        return (this.getValue(field) !== undefined) && (this.getValue(field) !== false) && (this.getValue(field) !== '');
    }
}
